import { RestClient, Loggable, Logger } from '@reyaxyz/common';

import { GetLpTvlResult } from './types';

export default class LGEModule extends RestClient implements Loggable {
  loggingEnabled: boolean = false;

  constructor(apiUrl: string, loggingEnabled: boolean) {
    super(apiUrl);
    this.loggingEnabled = loggingEnabled;
  }

  @Logger('LGEModule.getLpTvl')
  async getLpTvl() {
    const uri = `/api/xp/lp-tvl`;
    return this.get<GetLpTvlResult>(uri);
  }
}
